<section class="bg-primary-500 dark:bg-surface-950 p-8 lg:p-20">
	<div class="flex flex-col gap-8">
		<div class="flex flex-col gap-4">
			<app-headline-large
				[title]="content.title"
				class="text-surface-0!"></app-headline-large>
			<app-body-large [description]="content.description"></app-body-large>
		</div>

		<div
			class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
			@for (testimonial of testimonials; track testimonial.title) {
			<div class="bg-surface-0 dark:bg-surface-900 shadow-sm p-8 flex-row gap-6">
				<div class="flex gap-4">
					<svg
						class="w-10 h-10"
						xmlns="http://www.w3.org/2000/svg"
						width="40"
						height="41"
						viewBox="0 0 40 41"
						fill="none">
						<path
							d="M10.7287 27.1513C9.44125 25.7838 8.75 24.2501 8.75 21.7638C8.75 17.3888 11.8212 13.4676 16.2875 11.5288L17.4037 13.2513C13.235 15.5063 12.42 18.4326 12.095 20.2776C12.7662 19.9301 13.645 19.8088 14.5062 19.8888C16.7612 20.0976 18.5387 21.9488 18.5387 24.2501C18.5387 25.4104 18.0778 26.5232 17.2573 27.3437C16.4369 28.1641 15.3241 28.6251 14.1637 28.6251C12.8225 28.6251 11.54 28.0126 10.7287 27.1513ZM23.2287 27.1513C21.9412 25.7838 21.25 24.2501 21.25 21.7638C21.25 17.3888 24.3212 13.4676 28.7875 11.5288L29.9037 13.2513C25.735 15.5063 24.92 18.4326 24.595 20.2776C25.2662 19.9301 26.145 19.8088 27.0062 19.8888C29.2612 20.0976 31.0387 21.9488 31.0387 24.2501C31.0387 25.4104 30.5778 26.5232 29.7573 27.3437C28.9369 28.1641 27.8241 28.6251 26.6637 28.6251C25.3225 28.6251 24.04 28.0126 23.2287 27.1513Z"
							class="fill-rdus-orange-dark-500" />
					</svg>
				</div>
				<div class="flex flex-col items-start gap-4 mt-6">
					<p class="text-base text-surface-900 dark:text-surface-400 leading-normal">{{ testimonial.title }}</p>

					<h3 class="text-lg font-semibold text-primary-800 dark:text-surface-0 leading-tight">
						{{ testimonial.description }}
					</h3>
				</div>
			</div>
			}
		</div>
	</div>
</section>
